import React from "react";

import type { DesignaliIcon, DesignaliProps } from "./types";

import {
  AArrowDown,
  AArrowUp,
  Access01,
  Accessibility01,
  Activity,
  AiBeautify,
  AiBook,
  AiBrain01,
  AiBrain02,
  AiBrain03,
  AiBrain04,
  AiBrain05,
  AiBrowser,
  AiChat01,
  AiChat02,
  AiChemistry01,
  AiChemistry02,
  AiChemistry03,
  AiChip,
  AiCloud,
  AiCloud01,
  AiCloud02,
  AiComputer,
  AiContentGenerator01,
  AiContentGenerator02,
  AiDna,
  AiEditing,
  AiEraser,
  AiFile,
  AiFolder01,
  AiFolder02,
  AiGame,
  AiGenerative,
  AiIdea,
  AiImage,
  AiInnovation01,
  AiInnovation02,
  AiInnovation03,
  AiLaptop,
  AiLearning,
  AiLock,
  AiMagic,
  AiMail,
  AiMail01,
  AiMail02,
  AiMic,
  AiNetwork,
  AiPhone01,
  AiPhone02,
  AiProgramming,
  Airplay,
  AirVent,
  AiScan,
  AiScheduling,
  AiSearch,
  AiSearch01,
  AiSecurity01,
  AiSecurity02,
  AiSecurity03,
  AiSetting,
  AiSheets,
  AiSmartWatch,
  AiUser,
  AiVedio,
  AiView,
  AiVisionRecognition,
  AiVoice,
  AiVoiceGenerator,
  AiWebBrowsing,
  ALargeSmall,
  AlarmClock,
  AlarmClockCheck,
  AlarmClockOff,
  AlarmClockPlus,
  AlarmSmoke,
  Alert01,
  Alert02,
  AlertCircle,
  AlertDiamond,
  AlertSquare,
  Algorithm,
  AlignCenter,
  AlignCenterHorizontal,
  AlignCenterVertical,
  AlignEndHorizontal,
  AlignEndVertical,
  AlignHorizontalDistributeCenter,
  AlignHorizontalDistributeEnd,
  AlignHorizontalDistributeStart,
  AlignHorizontalJustifyCenter,
  AlignHorizontalJustifyEnd,
  AlignHorizontalJustifyStart,
  AlignHorizontalSpaceAround,
  AlignHorizontalSpaceBetween,
  AlignJustify,
  AlignLeft,
  AlignRight,
  AlignStartHorizontal,
  AlignStartVertical,
  AlignVerticalDistributeCenter,
  AlignVerticalDistributeEnd,
  AlignVerticalDistributeStart,
  AlignVerticalJustifyCenter,
  AlignVerticalJustifyEnd,
  AlignVerticalJustifyStart,
  AlignVerticalSpaceAround,
  AlignVerticalSpaceBetween,
  Ambulance,
  Ampersand,
  Ampersands,
  Amphora,
  Anchor,
  Angry,
  AnimationMoveBottom,
  AnimationMoveLeft,
  AnimationMoveTop,
  Annoyed,
  Antenna,
  Apple,
  Apple1,
  AppleIntelligence,
  AppWindow,
  AppWindowMac,
  Archive,
  ArchiveRestore,
  ArchiveX,
  Armchair,
  ArrowBigDown,
  ArrowBigDownDash,
  ArrowBigLeft,
  ArrowBigLeftDash,
  ArrowBigRight,
  ArrowBigRightDash,
  ArrowBigUp,
  ArrowBigUpDash,
  ArrowDown,
  ArrowDown01,
  ArrowDown10,
  ArrowDownAZ,
  ArrowDownFromLine,
  ArrowDownLeft,
  ArrowDownNarrowWide,
  ArrowDownRight,
  ArrowDownToDot,
  ArrowDownToLine,
  ArrowDownUp,
  ArrowDownWideNarrow,
  ArrowDownZA,
  ArrowLeft,
  ArrowLeftFromLine,
  ArrowLeftRight,
  ArrowLeftToLine,
  ArrowRight,
  ArrowRightFromLine,
  ArrowRightLeft,
  ArrowRightToLine,
  ArrowsUpFromLine,
  ArrowUp,
  ArrowUp01,
  ArrowUp10,
  ArrowUpAZ,
  ArrowUpDown,
  ArrowUpFromDot,
  ArrowUpFromLine,
  ArrowUpLeft,
  ArrowUpNarrowWide,
  ArrowUpRight,
  ArrowUpToLine,
  ArrowUpWideNarrow,
  ArrowUpZA,
  ArtificialIntelligence01,
  ArtificialIntelligence02,
  ArtificialIntelligence03,
  ArtificialIntelligence04,
  ArtificialIntelligence05,
  ArtificialIntelligence06,
  ArtificialIntelligence07,
  Asterisk,
  AtSign,
  AudioLine,
  AudioLines,
  AudioWaveform,
  Award,
  Award01,
  Award02,
  Award03,
  Award04,
  Award05,
  Axe,
  Axis3d,
  Baby,
  Baby01,
  Baby02,
  Baby03,
  Baby04,
  BabyBed01,
  BabyBed02,
  BabyBottle,
  BabyBoyDress,
  BabyGirlDress,
  Backpake,
  Badge,
  Badge01,
  BadgeAlert,
  BadgeCent,
  BadgeCheck,
  BadgeCheck01,
  BadgeCheck02,
  BadgeCheck03,
  BadgeCheck04,
  BadgeDollarSign,
  BadgeEuro,
  BadgeHelp,
  BadgeIndianRupee,
  BadgeInfo,
  BadgeJapaneseYen,
  BadgeMinus,
  BadgePercent,
  BadgePlus,
  BadgePoundSterling,
  BadgeRussianRuble,
  BadgeSwissFranc,
  BadgeX,
  Ban,
  Banana,
  Bandage,
  Banknote,
  Baseline,
  Battery,
  BatteryCharging,
  BatteryFull,
  BatteryLow,
  BatteryMedium,
  BattreyWarning,
  Beaker,
  Bean,
  BeanOff,
  Bed,
  BedDouble,
  BedSingle,
  Beer,
  BeerOff,
  Behance,
  BehanceFull,
  Bell,
  BellDot,
  BellElectric,
  BetweenHorizontalEnd,
  BetweenHorizontalStart,
  BetweenVerticalEnd,
  BetweenVerticalStart,
  BicepsFlexed,
  Binary,
  Binoculars,
  BiometricAccess,
  Bird,
  Bitcoin,
  Blend,
  Blinds,
  Blocks,
  Bluetooth,
  BluetoothConnected,
  BluetoothOff,
  BluetoothSearching,
  Bold,
  Bolt,
  Book,
  BookA,
  BookAudio,
  BookCheck,
  BookCopy,
  BookDashed,
  BookDown,
  BookHeadphones,
  BookHeart,
  BookImage,
  BookKey,
  BookLock,
  Bookmark,
  BookmarkCheck,
  BookMarked,
  BookmarkMinus,
  BookmarkPlus,
  BookmarkX,
  BookMinus,
  BookOpen,
  BookOpenCheck,
  BookOpenText,
  BookPlus,
  BookText,
  BookType,
  BookUp,
  BookUp2,
  BookUser,
  BookX,
  BoomBox,
  Bot,
  BotMessageSquare,
  BotOff,
  BounceLeft,
  BounceRight,
  Box,
  Boxes,
  BoxSelect,
  Braces,
  Brackets,
  Brain,
  BrainCircuit,
  BrainCog,
  BriefcaseMedical,
  BringToFront,
  Brush,
  BubbleChat,
  BubbleChatAdd,
  BubbleChatBlocked,
  BubbleChatCancel,
  BubbleChatDelay,
  BubbleChatDone,
  BubbleChatDownload01,
  BubbleChatDownload02,
  BubbleChatEdit,
  BubbleChatFavourite,
  BubbleChatIncome,
  BubbleChatLock,
  BubbleChatNotification,
  BubbleChatOutcome,
  BubbleChatPreview,
  BubbleChatQuestion,
  BubbleChatSearch,
  BubbleChatSecure,
  BubbleChatTranslate,
  BubbleChatUnlock,
  BubbleChatUpload,
  BubbleChatUser,
  Bug,
  BugOff,
  BugPlay,
  Building01,
  Building02,
  Building03,
  Building04,
  Building05,
  Building06,
  Building07,
  Building08,
  Cable,
  Cake,
  CakeSlice,
  Calculator,
  CalenderFold,
  Camel,
  Camera,
  CameraOff,
  Candy,
  CandyCane,
  CandyOff,
  Cannabis,
  Captions,
  CaptionsOff,
  CarAlert,
  Caravan,
  Carrot,
  CaseLower,
  CaseSensitive,
  CaseUpper,
  CassetteTape,
  Cast,
  Cat,
  Cctv,
  Certificate01,
  Champion,
  ChartArea,
  ChartBar,
  ChartBarBig,
  ChartBarDecreasing,
  ChartBarIncreasing,
  ChartBarStacked,
  ChartCandlestick,
  ChartColumn,
  ChartColumnBig,
  ChartColumnDecreasing,
  ChartColumnIncreasing,
  ChartColumnStacked,
  ChartLine,
  ChartNetwork,
  ChartNoAxesColumn,
  ChartNoAxesColumnDecreasing,
  ChartNoAxesColumnIncreasing,
  ChartNoAxesCombined,
  ChartNoAxesGantt,
  ChartPie,
  ChartScatter,
  ChartSpline,
  ChatBot,
  Chatting01,
  Check,
  Cherry,
  ChevronDown,
  ChevronFirst,
  ChevronLast,
  ChevronLeft,
  ChevronRight,
  ChevronsDown,
  ChevronsDownUp,
  ChevronsLeft,
  ChevronsLeftRight,
  ChevronsLeftRightEllipsis,
  ChevronsRight,
  ChevronsRightLeft,
  ChevronsUp,
  ChevronsUpDown,
  ChevronUp,
  Chip,
  Cigarette,
  CigaretteOff,
  CircleArrowDown,
  CircleArrowLeft,
  CircleArrowOutDownLeft,
  CircleArrowOutDownRight,
  CircleArrowOutUpLeft,
  CircleArrowOutUpRight,
  CircleArrowRight,
  CircleArrowUp,
  CircleChevronDown,
  CircleChevronLeft,
  CircleChevronRight,
  CircleChevronUp,
  CircleDashed,
  CircleDivide,
  CircleDollarSign,
  CircleDot,
  CircleDotDashed,
  CircleEllipsis,
  CircleEqual,
  CircleFadingArrowUp,
  CircleFadingPlus,
  CircleGauge,
  CircleHelp,
  CircleMinus,
  CircleParking,
  CircleParkingOff,
  CirclePause,
  CirclePercent,
  CirclePlay,
  CirclePlus,
  CirclePower,
  CircleSlash,
  CircleSlash2,
  CircleStop,
  CircleUser,
  CircleUserRound,
  CircleX,
  CircuitBoard,
  Citrus,
  Clapperboard,
  ClipboardCheck,
  ClipboardCopy,
  ClipboardList,
  ClipboardMinus,
  ClipboardPaste,
  ClipboardPen,
  ClipboardPenLine,
  ClipboardPlus,
  ClipboardType,
  ClipboardX,
  Close,
  CloudAlert,
  CloudCog,
  CloudDownload,
  CloudServer,
  CloudUpload,
  Clover,
  Club,
  Code,
  CodePen,
  CodeXml,
  Coffee,
  Cog,
  Coins,
  CokingPot,
  ColudOff,
  Columns2,
  Columns3,
  Columns4,
  Combine,
  Command,
  Comment01,
  Comment02,
  CommentRemove02,
  Compass,
  Component,
  Computer,
  Cone,
  Construction,
  Contact,
  ContactRound,
  Container,
  Contrast,
  Cookie,
  CookingPot,
  Copy,
  CopyCheck,
  CopyMinus,
  CopyPlus,
  CopySlash,
  CornerDownLeft,
  CornerDownRight,
  CornerLeftDown,
  CornerLeftUp,
  CornerRightDown,
  CornerRightUp,
  CornerUpLeft,
  CornerUpRight,
  Cpu,
  Crab,
  CreditCard,
  Croissant,
  Crop,
  Crown,
  CupSoda,
  Currency,
  Cylinder,
  DaimondMinus,
  DaimondPlus,
  DataBase,
  DataBaseBackup,
  DatabaseBackup,
  DatabaseZap,
  Delete,
  Dessert,
  Diameter,
  DiamondMinus,
  DiamondPercent,
  DiamondPlus,
  Diaper,
  Dice1,
  Dice2,
  Dice3,
  Dice4,
  Dice5,
  Dice6,
  Dices,
  Diff,
  Disc,
  Disc2,
  Disc3,
  DiscAlbum,
  Divide,
  Dna,
  DnaOff,
  Dock,
  Dog,
  DollarSign,
  Donut,
  DoorClosed,
  DoorOpen,
  Download,
  DraftingCompass,
  Drama,
  Drill,
  Droplet,
  Drum,
  DrumStick,
  Dumbbell,
  Ear,
  EarOff,
  Earth,
  EarthLock,
  EaseCurveControlPoints,
  EaseIn,
  EaseInControlPoint,
  EaseInOut,
  EaseOut,
  EaseOutControlPoint,
  EathernetPort,
  Eclipse,
  EggFried,
  EggOff,
  EllipsisVertical,
  Equal,
  EqualNot,
  Eraser,
  Euro,
  Expand,
  ExternalLink,
  Eye,
  EyeOff,
  Facebook,
  Fan,
  FastForward,
  Feather,
  FerrisWheel,
  Figma,
  FileArchive,
  FileAudio,
  FileAudio2,
  FileAxis3D,
  FileAxis3d,
  FileBadge,
  FileBox,
  FileChartColumn,
  FileChartColumnIncreasing,
  FileChartLine,
  FileChartPie,
  FileCheck,
  FileCheck2,
  FileClock,
  FileCode,
  FileCog,
  FileDiff,
  FileDigit,
  FileDown,
  FileHeart,
  FileImage,
  FileInput,
  FileJosn2,
  FileJson,
  FileJson2,
  FileKey,
  FileKey2,
  FileLock,
  FileLock2,
  FileMinus,
  FIleMinus2,
  FileMusic,
  FileOutput,
  FilePen,
  FilePenLine,
  FilePlus,
  FilePlus2,
  Files,
  FileScan,
  FileSearch,
  FileSearch2,
  FileSlider,
  FileSliders,
  FileSpreadsheet,
  FileStack,
  FileSymilink,
  FileTerminal,
  FileText,
  FileType,
  FileType2,
  FileUp,
  FileVideo,
  FileVideo2,
  FileVolume,
  FileVolume2,
  FileWarning,
  FileX,
  FileX2,
  Film,
  Filter,
  FilterX,
  Fingerprint,
  FireExtinguisher,
  Fish,
  FishOff,
  FishSymbol,
  Flag,
  FlagOff,
  FlagTriangleLeft,
  FlagTriangleRight,
  Flame,
  FlameKinding,
  FlameKindling,
  Flashlight,
  FlashlightOff,
  FlaskConical,
  FlaskConicalOff,
  FlaskRound,
  FlipHorizontal,
  FlipHorizontal2,
  FlipVertical,
  FlipVertical2,
  Flower,
  Flower2,
  Folder,
  FolderArchive,
  FolderCheck,
  FolderClock,
  FolderClosed,
  FolderCode,
  FolderCog,
  FolderDot,
  FolderDown,
  FolderGit,
  FolderGit2,
  FolderHeart,
  FolderInput,
  FolderKanban,
  FolderKey,
  FolderLock,
  FolderMinus,
  FolderOpen,
  FolderOpenDot,
  FolderOpneDot,
  FolderOutput,
  FolderPen,
  FolderPlus,
  FolderRoot,
  Folders,
  FolderSearch,
  FolderSearch2,
  FolderSync,
  FolderTree,
  FolderUp,
  FolderX,
  FoldHorizontal,
  FoldVertical,
  Footprints,
  Forward,
  Frame,
  Frown,
  Fuel,
  Fullscreen,
  GalleryHorizontal,
  GalleryHorizontalEnd,
  GalleryThumbnails,
  GalleryVertical,
  GalleryVerticalEnd,
  Gamepad,
  Gamepad2,
  Gauge,
  Gavel,
  Gem,
  Ghost,
  Gift,
  GitBranch,
  GitBranchPlus,
  GitCommitHorizontal,
  GitCommitVertical,
  GitCompare,
  GitCompareArrows,
  GitGraph,
  GitLab,
  GitMerge,
  GitPullRequest,
  GitPullRequestArrow,
  GitPullRequestCreate,
  GitPullRequestCreateArrow,
  Glasses,
  GlassWater,
  Globe,
  GlobeLock,
  Goal,
  Grab,
  Grape,
  Grid2x2,
  Grid2X2,
  Grid2x2Check,
  Grid2X2Check,
  Grid2x2X,
  Grid2X2X,
  Grid3x3,
  Grid3X3,
  Grip,
  GripHorizontal,
  GripVertical,
  Group,
  GuestHouse,
  Guitar,
  Ham,
  Hammer,
  Hand,
  HandCoins,
  HandHelping,
  HandMetal,
  HandPlater,
  Handshake,
  HardDrive,
  HardDriveDownload,
  HardDriveUpload,
  Hash,
  HdmiPort,
  Heading,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Heading5,
  Heading6,
  Headphones,
  Headset,
  Heart1,
  HeartCrack,
  HeartHandShake,
  HeartHandshake,
  HeartPulse,
  Hexagon,
  Highlighter,
  History,
  Hologram,
  Home01,
  Home02,
  Home03,
  Home04,
  Home05,
  Home06,
  Home07,
  Home08,
  Home09,
  Honor,
  HonourStar,
  Hop,
  HopOff,
  Horse,
  HorseHead,
  HorseSaddle,
  HourGlass,
  House,
  House01,
  House02,
  House03,
  House04,
  House05,
  HousePlug,
  HousePlus,
  HouseSolarPanel,
  IceCreamBowl,
  IceCreamCone,
  IdCard,
  Image,
  ImageDown,
  ImageMinus,
  ImageOff,
  ImagePlay,
  ImagePlus,
  Images,
  Import,
  Inbox,
  IndentDecrease,
  IndentIncrease,
  IndianRupee,
  Infinit,
  Info,
  Instagram,
  Italic,
  IterationCc,
  IterationCcw,
  IterationCw,
  JapaneseYen,
  Joystick,
  Kanban,
  Key,
  Keyboard,
  KeyboardMusic,
  KeyboardOff,
  Keyframe,
  KeyframeAdd,
  KeyframeAlignCenter,
  KeyframeAlignHorizontal,
  KeyframeAlignVertical,
  KeyframeBottom,
  KeyframeDouble,
  KeyframeDoubleRemove,
  KeyframeLeft,
  KeyframeMultiple,
  KeyframeMultipleAdd,
  KeyframeMultipleRemove,
  KeyframeRemove,
  KeyframeRight,
  KeyframeTop,
  KeyRound,
  KeySquare,
  Lamp,
  LampCeiling,
  LampDesk,
  LampFloor,
  LampWallDown,
  LampWallUp,
  LandPlot,
  Languages,
  Laptop,
  LaptopMinimal,
  Lasso,
  LassoSelect,
  Laugh,
  LaurelWreath01,
  LaurelWreath02,
  LaurelWreathFirst01,
  LaurelWreathFirst02,
  LaurelWreathLeft01,
  LaurelWreathLeft02,
  LaurelWreathLeft03,
  LaurelWreathRight01,
  LaurelWreathRight02,
  LaurelWreathRight03,
  Layers,
  Layers2,
  Layers3,
  LayoutDashboard,
  LayoutGrid,
  LayoutList,
  LayoutPanelLeft,
  LayoutTemplate,
  Leaf,
  LeafyGreen,
  Lectern,
  LetterText,
  Library,
  LibraryBig,
  LifeBuoy,
  Ligature,
  LightHouse,
  Liner,
  Link,
  Link2,
  LinkedIn,
  List,
  ListCheck,
  ListChecks,
  ListCollapse,
  ListEnd,
  ListFilter,
  ListMinus,
  ListMusic,
  ListPlus,
  ListRestart,
  ListStart,
  ListTodo,
  ListTree,
  ListVideo,
  ListX,
  Loader,
  LoaderCircle,
  LoaderCricle,
  LoaderPinwheel,
  Locate,
  LocateFixed,
  LocateOff,
  LogIn,
  Login01,
  Login02,
  Login03,
  LoginCircle01,
  LoginCircle02,
  LoginSquare01,
  LoginSquare02,
  LogOut,
  Logs,
  Lollipop,
  MachineRobot,
  MagicWand,
  Magnet,
  Mail,
  Mailbox,
  MailCheck,
  MailMinus,
  MailOpen,
  MailOpen01,
  MailOpen02,
  MailOpenLove,
  MailPlus,
  MailQuestion,
  Mails,
  MailSearch,
  MailWarning,
  MailX,
  Map,
  MapPin,
  MapPinCheck,
  MapPinCheckInside,
  MapPinHouse,
  MapPinMinus,
  MapPinMinusInside,
  MapPinned,
  MapPinPlus,
  MapPinPlusInside,
  MapPinX,
  MapPinXInside,
  Martini,
  Maximize,
  Maximize2,
  Medal,
  Medal01,
  Medal02,
  Medal03,
  Medal04,
  Medal05,
  Medal06,
  Medal07,
  MedalFirstPlace,
  MedalSecondPlace,
  MedalThirdPlace,
  Megaphone,
  MegaphoneOff,
  Meh,
  Memorystick,
  MemoryStick,
  Menu,
  Merge,
  Message02,
  MessageBlocked,
  MessageCircle,
  MessageCircleCode,
  MessageCircleDashed,
  MessageCircleMore,
  MessageCircleOff,
  MessageCirclePlus,
  MessageCircleQuestion,
  MessageCircleReply,
  MessageCircleWarning,
  MessageCircleX,
  MessageDone02,
  MessageSquare,
  MessageSquareCode,
  MessageSquareDashed,
  MessageSquareDiff,
  MessageSquareDot,
  MessageSquareMore,
  MessageSquareOff,
  MessageSquarePlus,
  MessageSquareQuote,
  MessageSquareReply,
  MessageSquareShare,
  MessageSquareText,
  MessageSquareWarning,
  MessageSquareX,
  Mic,
  MicOff,
  Microchip,
  Microscope,
  Microwave,
  MicVocal,
  MileSton,
  Milestone,
  Milk,
  Minimize,
  Minimize2,
  Minus,
  Monitor,
  MonitorCheck,
  MonitorCog,
  MonitorDot,
  MonitorDown,
  MonitorOff,
  MonitorPause,
  MonitorPlay,
  MonitorSmartphone,
  MonitorSpeaker,
  MonitorStop,
  MonitorUp,
  MonitorX,
  Moon,
  MoonStar,
  Motion01,
  Motion02,
  Mountain,
  MountainSnow,
  Mouse,
  MouseOff,
  MousePointer,
  MousePointer2,
  MousePointerBan,
  MousePointerClick,
  Move,
  Move3D,
  MoveDiagonal,
  MoveDiagonal2,
  MoveDown,
  MoveDownLeft,
  MoveDownRight,
  MoveHorizontal,
  MoveLeft,
  MoveRight,
  MoveUp,
  MoveUpLeft,
  MoveUpRight,
  MoveVertical,
  Music,
  Music2,
  Music3,
  Music4,
  Navigation,
  Navigation2,
  Navigation2Off,
  NavigationOff,
  Network,
  NeuralNetwork,
  NewReleases,
  Newspaper,
  Nextjs,
  Nfc,
  Nike,
  Nootbook,
  NootbookTabs,
  Notebook,
  NotebookPen,
  NotebookTabs,
  NotebookText,
  NotepadText,
  NotepadTextDashed,
  NPM,
  Nut,
  NutOff,
  OctagonAlert,
  OctagonPause,
  OctagonX,
  Omega,
  Option,
  Origami,
  Package,
  Package2,
  PackageMinus,
  PackageOpen,
  PackageSearch,
  PackageX,
  PaintbrushVertical,
  PaintRoller,
  Palette,
  PanelBottom,
  PanelBottomClose,
  PanelBottomDashed,
  PanelBottomOpen,
  PanelLeft,
  PanelLeftClose,
  PanelLeftDashed,
  PanelLeftOpen,
  PanelRight,
  PanelRightClose,
  PanelRightDashed,
  PanelRightOpen,
  PanelsLeftBottom,
  PanelsRightBottom,
  PanelsTopLeft,
  PanelTop,
  PanelTopClose,
  PanelTopDashed,
  PanelTopOpen,
  PaperClip,
  Paperclip,
  Parentheses,
  ParkingMeter,
  PartyPopper,
  Pause,
  PawPrint,
  PcCase,
  Pen,
  Pencil,
  PencilLine,
  PencilOff,
  PencilRuler,
  PenOff,
  PenTool,
  Percent,
  PerplexityAi,
  PersonStanding,
  PhilippinePeso,
  Phone,
  PhoneCall,
  PhoneForwarded,
  PhoneIncoming,
  PhoneMissed,
  PhoneOff,
  PhoneOutgoing,
  Pi,
  Piano,
  Pickaxe,
  PictureInPicture,
  PictureInPicture2,
  Pilcrow,
  PilcrowLeft,
  PilcrowRight,
  Pill,
  PillBottle,
  Pin,
  PinOff,
  Pipette,
  Pizza,
  Play,
  Plug,
  Plug2,
  PlugZap,
  Plus,
  Pocket,
  Podcast,
  Pointer,
  PointerOff,
  Popcorn,
  Popsicle,
  PoundSterling,
  Power,
  PowerOff,
  Presentation,
  Printer,
  PrinterCheck,
  Projector,
  Proportions,
  Puzzle,
  Pyramid,
  QrCode,
  Quote,
  Rabbit,
  Radar,
  Radical,
  RadioReceiver,
  RadioTower,
  Radius,
  RailSymbol,
  Ranking,
  Rat,
  Ratio,
  Receipt,
  ReceiptCent,
  ReceiptEuro,
  ReceiptIndianRupee,
  ReceiptJapneseYen,
  ReceiptPoundSterling,
  ReceiptRussianRuble,
  ReceiptSwissFranc,
  RectangleElliopsis,
  RectangleEllipsis,
  RectangleHorizontal,
  RectangleVertical,
  Redo,
  Redo2,
  RedoDot,
  RefreshCcw,
  RefreshCcwDot,
  RefreshCw,
  RefreshCwOff,
  Refrigeator,
  Refrigerator,
  Regex,
  RemoveFormatting,
  Repeat,
  Repeat1,
  Repeat2,
  Replace,
  ReplaceAll,
  Reply,
  ReplyAll,
  Rewind,
  Ribbon,
  Robot01,
  Robot02,
  Robotic,
  Rocket,
  RockingChair,
  RollerCoaster,
  Rotate3D,
  RotateCcw,
  RotateCcwSquare,
  RotateCw,
  RotateCwSquare,
  Route,
  RouteOff,
  Router,
  Rows2,
  Rows3,
  Rows4,
  Rss,
  RubberDuck,
  Ruler,
  RussianRubie,
  Salad,
  SandWich,
  Satellite,
  SatelliteDish,
  Save,
  SaveAll,
  SaveOff,
  Scale,
  Scale3D,
  Scaling,
  Scan,
  Scane,
  ScanEye,
  ScanFace,
  ScanLine,
  ScanQrCode,
  ScanSearch,
  ScanText,
  Scissors,
  ScissorsLineDashed,
  ScreenShare,
  ScreenShareOff,
  Scroll,
  Scrolltext,
  ScrollText,
  Search,
  SearchCheck,
  SearchCode,
  SearchSlash,
  SearchX,
  Section,
  Send,
  SendHorizontal,
  SendToBack,
  SeparatorHorizontal,
  SeparatorVertical,
  Server,
  ServerCog,
  ServerCrash,
  ServerOff,
  SettingError01,
  SettingError02,
  SettingError03,
  SettingError04,
  Settings,
  Settings2,
  Shapes,
  Share,
  Share2,
  Sheet,
  ShefHat,
  Shell,
  Shellfish,
  Shield,
  ShieldAlert,
  ShieldBan,
  ShieldCheck,
  ShieldEllipsis,
  ShieldHalf,
  ShieldMinus,
  ShieldOff,
  ShieldPlus,
  ShieldQuestion,
  ShieldX,
  Ship,
  ShipWheel,
  Shovel,
  ShowerHead,
  Shrink,
  Shuffle,
  Sigma,
  Signal,
  SignalHigh,
  SignalLow,
  SignalMedium,
  SignalZero,
  Signature,
  Signpost,
  SignpostBig,
  SingPost,
  SingPostBig,
  Siren,
  SiriNew,
  SkipBack,
  SkipForward,
  Skull,
  Slash,
  Slice,
  SlidersHorizontal,
  SlidersVertical,
  Smartphone,
  SmartphoneCharging,
  SmartphoneNfc,
  Smile,
  SmilePlus,
  Snail,
  Soup,
  Space,
  Spade,
  Sparkles,
  Speaker,
  Speech,
  SpellCheck,
  SpellCheck2,
  Spline,
  Split,
  SprayCan,
  Sprout,
  SquareActivity,
  SquareArrowDown,
  SquareArrowDownLeft,
  SquareArrowDownRight,
  SquareArrowLeft,
  SquareArrowOutDownLeft,
  SquareArrowOutDownRight,
  SquareArrowOutUpLeft,
  SquareArrowOutUpRight,
  SquareArrowRight,
  SquareArrowUp,
  SquareArrowUpLeft,
  SquareArrowUpRight,
  SquareAsterisk,
  SquareBottomDashedScissors,
  SquareChartGantt,
  SquareChevronDown,
  SquareChevronLeft,
  SquareChevronRight,
  SquareChevronUp,
  SquareCode,
  SquareDashedBottom,
  SquareDashedBottomCode,
  SquareDashedKanban,
  SquareDashedMousePointer,
  SquareDivide,
  SquareDot,
  SquareEqual,
  SquareFunction,
  SquareKanban,
  SquareLibrary,
  SquareM,
  SquareMenu,
  SquareMinus,
  SquareMousePointer,
  SquareParking,
  SquareParkingOff,
  SquarePen,
  SquarePercent,
  SquarePi,
  SquarePilcrow,
  SquarePlay,
  SquarePlus,
  SquarePower,
  SquareRadical,
  SquareScissors,
  SquareSigma,
  SquareSlash,
  SquareSplitHorizontal,
  SquareSplitVertical,
  SquareSquare,
  SquareStack,
  SquareTerminal,
  SquareUser,
  SquareUserRound,
  SquareX,
  Squirrel,
  Stamp,
  Star,
  StarAward01,
  StarAward02,
  StarHalf,
  StarOff,
  StepBack,
  StepForward,
  Stethoscope,
  Sticker,
  StickyNote,
  StretchHorizontal,
  StretchVertical,
  Strikethrough,
  Subscript,
  Sun,
  SunDim,
  SunMedium,
  SunMoon,
  Sunrise,
  Sunset,
  Superscript,
  SwatchBook,
  SwissFranc,
  SwitchCamera,
  Sword,
  Syringe,
  TableCellsSplit,
  TableColumnsSplit,
  TableProperties,
  TablePropertise,
  TableRowsSplit,
  TableSmartphone,
  Tablet,
  Tablets,
  TabletSmartphone,
  Tag,
  Tags,
  Tally1,
  Tally2,
  Tally3,
  Tally4,
  Tally5,
  Tangent,
  Tangent2,
  Target,
  Telescope,
  Tent,
  TentTree,
  Terminal,
  Text,
  TextCursor,
  TextCursorInput,
  TextQuote,
  TextSearch,
  TextSelect,
  Threads,
  ThreadsFill,
  ThumbsDown,
  ThumbsUp,
  Ticket,
  TicketCheck,
  TicketMinus,
  TicketPercent,
  TicketPlus,
  Tickets,
  TicketSlash,
  TicketX,
  ToggleLeft,
  ToggleRight,
  Torus,
  ToyBrick,
  ToyTrain,
  Tractor,
  TrainFrontTunnel,
  TrainTrack,
  TransitionBottom,
  TransitionLeft,
  TransitionRight,
  TransitionTop,
  Trash,
  Trash2,
  TreeDecidous,
  TreePalm,
  TreePine,
  Trees,
  Trello,
  TrendingDown,
  TrendingUp,
  TriangleAlert,
  Trophy,
  Turtle,
  Tv,
  TvMinimal,
  TvMinimalPlay,
  Type,
  TypeOutline,
  Typescript,
  Underline,
  Undo,
  Undo2,
  UndoDot,
  UnfoldHorizontal,
  UnfoldVertical,
  Ungroup,
  UnityPool,
  UniversalAccess,
  Unlink,
  Unlink2,
  Unplug,
  Upload,
  Usb,
  User,
  UserAccount,
  UserAdd01,
  UserAdd02,
  UserArrowLeftRight,
  UserBlock01,
  UserBlock02,
  UserCheck,
  UserCheck01,
  UserCheck02,
  UserCircle,
  UserCog,
  UserEdit01,
  UserFullView,
  UserGroup01,
  UserGroup02,
  UserList,
  UserLock01,
  UserLock02,
  UserLove01,
  UserLove02,
  UserMinus,
  UserMinus01,
  UserMinus02,
  UserPen,
  UserPlus,
  UserQuestion01,
  UserQuestion02,
  UserRemove01,
  UserRemove02,
  UserRound,
  UserRoundCheck,
  UserRoundCog,
  UserRoundMinus,
  UserRoundPen,
  UserRoundPlus,
  UserRoundSearch,
  UserRoundX,
  Users,
  UserSearch,
  UserSearch01,
  UserSearch02,
  UserSettings01,
  UserSettings02,
  UserSharing,
  UserShield01,
  UserShield02,
  UserSquare,
  UsersRound,
  UserStar01,
  UserStar02,
  UserStatus,
  UserStory,
  UserSwitch,
  UserUnlock01,
  UserUnlock02,
  UserX,
  Utensils,
  UtensilsCrossed,
  UtlensilsCrossed,
  ValentineMask,
  Variable,
  Vault,
  Vegan,
  VenetianMask,
  Vercel,
  VercelFull,
  Vibrate,
  VibrateOff,
  Video,
  VideoOff,
  Videotape,
  View,
  VoiceMail,
  Voicemail,
  Volume,
  Volume1,
  Volume2,
  VolumeOff,
  VolumeX,
  Wallet,
  WalletCards,
  WalletMinimal,
  Wallpaper,
  Wand,
  WandSparkles,
  Warehouse,
  Waves,
  Waypoints,
  Webcam,
  Webhook,
  WebhookOff,
  WeChat,
  Weight,
  WhatsApp,
  Wheat,
  Wheatoff,
  WholeWord,
  Wifi,
  WifiHigh,
  WifiLow,
  WifiOff,
  WifiZero,
  Wine,
  WineOff,
  Wordpress,
  WorkAlert,
  WorkFlow,
  Worm,
  WrapText,
  Wrench,
  X,
  XNum,
  YouTube,
  Zap,
  ZapOff,
  ZoomIn,
  ZoomOut,
} from "./icons";
import AiAudio from "./icons/ai/ai-audio";
import AnimationMoveRight from "./icons/animations/animation-move-right";
import HeartOff from "./icons/multimedia/HeartOff";

export type DIcon = DesignaliIcon;

export type ValidIcon = keyof typeof DIcons;

export const DIcons = {
  Designali: ({ ...props }: DesignaliProps) => (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="heart"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        strokeWidth={0}
        fill="currentColor"
        d="M2.8,1.43h7.53c3.47,0,6.15.92,8.04,2.75,1.89,1.84,2.83,4.45,2.83,7.85s-.92,5.98-2.77,7.8c-1.85,1.83-4.49,2.74-7.92,2.74H2.8V1.43Z"
      ></path>
    </svg>
  ),

  // Access

  Activity,
  Link,
  Link2,
  ScanEye,
  ScanFace,
  LogIn,
  LogOut,
  Fingerprint,
  ScanSearch,
  ScanQrCode,
  Access01,
  Login01,
  Login02,
  Login03,
  LoginCircle01,
  LoginCircle02,
  LoginSquare01,
  LoginSquare02,
  BiometricAccess,
  UniversalAccess,

  // Accessibility

  Accessibility01,
  CircleHelp,
  Contrast,
  Ear,
  EarOff,
  Eclipse,
  Eye,
  EyeOff,
  Glasses,
  Hand,
  Info,
  LifeBuoy,
  Moon,
  MoonStar,
  PersonStanding,
  Speech,
  Sun,
  SunDim,
  SunMedium,
  SunMoon,
  ZoomIn,
  ZoomOut,

  // Ai

  AiAudio,
  AiBeautify,
  AiBook,
  AiBrain01,
  AiBrain02,
  AiBrain03,
  AiBrain04,
  AiBrain05,
  AiBrowser,
  AiChat01,
  AiChat02,
  AiComputer,
  AiChemistry01,
  AiChemistry02,
  AiChemistry03,
  AiChip,
  AiCloud,
  AiCloud01,
  AiCloud02,
  AiContentGenerator01,
  AiContentGenerator02,
  AiDna,
  AiEditing,
  AiEraser,
  AiFile,
  AiFolder01,
  AiFolder02,
  AiGame,
  AiGenerative,
  AiIdea,
  AiImage,
  AiInnovation01,
  AiInnovation02,
  AiInnovation03,
  AiLaptop,
  AiLearning,
  AiLock,
  AiMagic,
  AiMail,
  AiMail01,
  AiMail02,
  AiMic,
  AiNetwork,
  AiPhone01,
  AiPhone02,
  AiProgramming,
  AiScan,
  AiScheduling,
  AiSearch,
  AiSearch01,
  AiSecurity01,
  AiSecurity02,
  AiSecurity03,
  AiSetting,
  AiSheets,
  AiSmartWatch,
  AiVedio,
  AiUser,
  AiView,
  AiVoice,
  AiVisionRecognition,
  AiVoiceGenerator,
  AiWebBrowsing,
  Algorithm,
  AppleIntelligence,
  ArtificialIntelligence01,
  ArtificialIntelligence02,
  ArtificialIntelligence03,
  ArtificialIntelligence04,
  ArtificialIntelligence05,
  ArtificialIntelligence06,
  ArtificialIntelligence07,
  ChatBot,
  Chip,
  CloudServer,
  Hologram,
  MachineRobot,
  MagicWand,
  NeuralNetwork,
  PerplexityAi,
  Robot01,
  Robot02,
  Robotic,
  SiriNew,

  // Accounts & Access

  AtSign,
  Award,
  Ban,
  Bell,
  BellDot,
  BetweenHorizontalEnd,
  BetweenHorizontalStart,
  Bolt,
  Bookmark,
  BookmarkCheck,
  BookmarkMinus,
  BookmarkPlus,
  BookmarkX,
  BookUser,
  Cake,
  CircleGauge,
  CirclePercent,
  CircleUser,
  CircleUserRound,
  ClipboardPenLine,
  Cog,
  Contact,
  ContactRound,
  Cookie,
  CreditCard,
  DiamondPercent,
  Flag,
  FlagOff,
  Frown,
  Gauge,
  Gift,
  HandCoins,
  Handshake,
  HeartHandshake,
  IdCard,
  Inbox,
  Key,
  KeyRound,
  KeySquare,
  Mail,
  MapPin,
  MapPinCheck,
  MapPinCheckInside,
  MapPinHouse,
  MapPinMinus,
  MapPinMinusInside,
  MapPinned,
  MapPinPlus,
  MapPinPlusInside,
  MapPinX,
  MapPinXInside,
  Menu,
  MessageCircle,
  MessageCircleCode,
  MessageCircleDashed,
  MessageCircleMore,
  MessageCircleOff,
  MessageCirclePlus,
  MessageCircleQuestion,
  MessageCircleReply,
  MessageCircleX,
  MessageSquare,
  MessageSquareCode,
  MessageSquareDashed,
  MessageSquareDiff,
  MessageSquareDot,
  MessageSquareMore,
  MessageSquareOff,
  MessageSquarePlus,
  MessageSquareQuote,
  MessageSquareReply,
  MessageSquareShare,
  MessageSquareText,
  MessageSquareX,
  NotebookTabs,
  Pin,
  Printer,
  PrinterCheck,
  Search,
  SearchCheck,
  SearchCode,
  SearchSlash,
  SearchX,
  Settings,
  Settings2,
  Share,
  Share2,
  Shield,
  ShieldBan,
  ShieldCheck,
  ShieldEllipsis,
  ShieldHalf,
  ShieldMinus,
  ShieldOff,
  ShieldPlus,
  ShieldQuestion,
  ShieldX,
  SlidersHorizontal,
  SlidersVertical,
  Smile,
  SquareActivity,
  SquareAsterisk,
  SquareMenu,
  SquarePercent,
  SquareUser,
  SquareUserRound,
  Star,
  Tag,
  Tags,
  ThumbsDown,
  ThumbsUp,
  Ticket,
  TicketCheck,
  TicketMinus,
  TicketPercent,
  TicketPlus,
  Tickets,
  TicketSlash,
  TicketX,
  ToggleLeft,
  ToggleRight,
  UserCheck,
  UserCog,
  UserMinus,
  UserPen,
  UserRoundPlus,
  UserRoundSearch,
  UserRoundX,
  Users,
  UserSearch,
  UsersRound,
  UserX,
  ValentineMask,
  Vibrate,
  VibrateOff,
  Wallet,
  WalletCards,
  WalletMinimal,
  Wallpaper,
  Waypoints,
  Webhook,
  WebhookOff,
  Wrench,

  // Animations

  AnimationMoveBottom,
  AnimationMoveLeft,
  AnimationMoveRight,
  AnimationMoveTop,
  BounceLeft,
  BounceRight,
  EaseCurveControlPoints,
  EaseIn,
  EaseInControlPoint,
  EaseInOut,
  EaseOut,
  EaseOutControlPoint,
  Keyframe,
  KeyframeAdd,
  KeyframeAlignCenter,
  KeyframeAlignHorizontal,
  KeyframeAlignVertical,
  KeyframeBottom,
  KeyframeLeft,
  KeyframeRemove,
  KeyframeRight,
  KeyframeDouble,
  KeyframeDoubleRemove,
  KeyframeMultiple,
  KeyframeMultipleAdd,
  KeyframeMultipleRemove,
  KeyframeTop,
  Liner,
  Motion01,
  Motion02,
  TransitionLeft,
  TransitionRight,
  TransitionTop,
  TransitionBottom,

  // Animals

  Bird,
  Bug,
  BugOff,
  BugPlay,
  Cat,
  Dog,
  Fish,
  FishOff,
  FishSymbol,
  Origami,
  PawPrint,
  Rabbit,
  Shell,
  Snail,
  Squirrel,
  Turtle,
  Worm,
  Rat,
  RubberDuck,
  Camel,
  Crab,
  Horse,
  HorseHead,
  HorseSaddle,
  Shellfish,

  // Alert

  Alert01,
  Alert02,
  AlertCircle,
  AlertDiamond,
  AlertSquare,
  SettingError03,
  SettingError04,
  SettingError01,
  SettingError02,
  CloudAlert,
  OctagonAlert,
  FileWarning,
  MessageCircleWarning,
  MessageSquareWarning,
  ShieldAlert,
  CarAlert,
  WorkAlert,

  // Arrow

  ArrowBigDown,
  ArrowBigDownDash,
  ArrowBigLeft,
  ArrowBigLeftDash,
  ArrowBigRight,
  ArrowBigRightDash,
  ArrowBigUp,
  ArrowBigUpDash,
  ArrowDown,
  ArrowDown01,
  ArrowDown10,
  ArrowDownAZ,
  ArrowDownFromLine,
  ArrowDownLeft,
  ArrowDownNarrowWide,
  ArrowDownRight,
  ArrowDownToDot,
  ArrowDownToLine,
  ArrowDownUp,
  ArrowDownWideNarrow,
  ArrowDownZA,
  ArrowLeft,
  ArrowLeftFromLine,
  ArrowLeftRight,
  ArrowLeftToLine,
  ArrowRight,
  ArrowRightFromLine,
  ArrowRightLeft,
  ArrowRightToLine,
  ArrowsUpFromLine,
  ArrowUp,
  ArrowUp01,
  ArrowUp10,
  ArrowUpAZ,
  ArrowUpDown,
  ArrowUpFromDot,
  ArrowUpFromLine,
  ArrowUpLeft,
  ArrowUpNarrowWide,
  ArrowUpRight,
  ArrowUpToLine,
  ArrowUpWideNarrow,
  ArrowUpZA,
  ChevronDown,
  ChevronFirst,
  ChevronLast,
  ChevronLeft,
  ChevronRight,
  ChevronsDown,
  ChevronsDownUp,
  ChevronsLeft,
  ChevronsLeftRight,
  ChevronsRight,
  ChevronsRightLeft,
  ChevronsUp,
  ChevronsUpDown,
  ChevronUp,
  CircleArrowDown,
  CircleArrowLeft,
  CircleArrowOutDownLeft,
  CircleArrowOutDownRight,
  CircleArrowOutUpLeft,
  CircleArrowOutUpRight,
  CircleArrowRight,
  CircleArrowUp,
  CircleChevronDown,
  CircleChevronLeft,
  CircleChevronRight,
  CircleChevronUp,
  CircleFadingArrowUp,
  ClipboardCopy,
  ClipboardPaste,
  CloudDownload,
  CloudUpload,
  CornerDownLeft,
  CornerDownRight,
  CornerLeftDown,
  CornerLeftUp,
  CornerRightDown,
  CornerRightUp,
  CornerUpLeft,
  CornerUpRight,
  DatabaseBackup,
  Delete,
  Download,
  ExternalLink,
  FastForward,
  FileDown,
  FileInput,
  FileOutput,
  FileUp,
  FolderDown,
  FolderInput,
  FolderOutput,
  FolderSync,
  FolderUp,
  FoldHorizontal,
  FoldVertical,
  GitCompare,
  GitCompareArrows,
  GitPullRequest,
  GitPullRequestArrow,
  GitPullRequestCreate,
  GitPullRequestCreateArrow,
  HardDriveDownload,
  HardDriveUpload,
  History,
  Import,
  IterationCcw,
  IterationCw,
  LassoSelect,
  Maximize2,
  Merge,
  Milestone,
  Minimize2,
  MousePointer,
  MousePointer2,
  MousePointerBan,
  MousePointerClick,
  Move,
  MoveDiagonal,
  MoveDiagonal2,
  MoveDown,
  MoveDownLeft,
  MoveDownRight,
  MoveHorizontal,
  MoveLeft,
  MoveRight,
  MoveUp,
  MoveUpLeft,
  MoveUpRight,
  MoveVertical,
  PanelBottomClose,
  PanelBottomOpen,
  PanelLeftClose,
  PanelLeftOpen,
  PanelRightClose,
  PanelRightOpen,
  PanelTopClose,
  PanelTopOpen,
  PhoneForwarded,
  PhoneIncoming,
  PhoneOutgoing,
  Play,
  Redo,
  Redo2,
  RedoDot,
  RefreshCcw,
  RefreshCcwDot,
  RefreshCw,
  RefreshCwOff,
  Repeat,
  Repeat2,
  Rewind,
  RotateCcw,
  RotateCcwSquare,
  RotateCw,
  RotateCwSquare,
  SeparatorHorizontal,
  SeparatorVertical,
  Shrink,
  Shuffle,
  Signpost,
  SignpostBig,
  SkipBack,
  SkipForward,
  Split,
  SquareArrowDown,
  SquareArrowDownLeft,
  SquareArrowDownRight,
  SquareArrowLeft,
  SquareArrowOutDownLeft,
  SquareArrowOutDownRight,
  SquareArrowOutUpLeft,
  SquareArrowOutUpRight,
  SquareArrowRight,
  SquareArrowUp,
  SquareArrowUpLeft,
  SquareArrowUpRight,
  SquareChevronDown,
  SquareChevronLeft,
  SquareChevronRight,
  SquareChevronUp,
  SquareDashedMousePointer,
  SquareMousePointer,
  SquarePlay,
  StepBack,
  StepForward,
  Sunrise,
  Sunset,
  Undo,
  Undo2,
  UndoDot,
  UnfoldHorizontal,
  UnfoldVertical,
  Upload,
  WrapText,

  // Awards

  Award01,
  Award02,
  Award03,
  Award04,
  Award05,
  Certificate01,
  Champion,
  Crown,
  Honor,
  HonourStar,
  LaurelWreath01,
  LaurelWreath02,
  LaurelWreathFirst01,
  LaurelWreathFirst02,
  LaurelWreathLeft01,
  LaurelWreathLeft02,
  LaurelWreathLeft03,
  LaurelWreathRight01,
  LaurelWreathRight02,
  LaurelWreathRight03,
  Medal01,
  Medal02,
  Medal03,
  Medal04,
  Medal05,
  Medal06,
  Medal07,
  MedalFirstPlace,
  MedalSecondPlace,
  MedalThirdPlace,
  NewReleases,
  Ranking,
  StarAward01,
  StarAward02,

  // Baby

  Baby01,
  Baby02,
  Baby03,
  Baby04,
  BabyBottle,
  BabyBoyDress,
  BabyGirlDress,
  BabyBed01,
  BabyBed02,
  ToyBrick,
  ToyTrain,
  Diaper,

  // Badge

  Badge01,
  BadgeAlert,
  BadgeCent,
  BadgeCheck,
  BadgeDollarSign,
  BadgeEuro,
  BadgeHelp,
  BadgeIndianRupee,
  BadgeInfo,
  BadgeJapaneseYen,
  BadgeMinus,
  BadgePlus,
  BadgeX,
  BadgePercent,
  BadgePoundSterling,
  BadgeRussianRuble,
  BadgeSwissFranc,
  BadgeCheck01,
  BadgeCheck02,
  BadgeCheck03,
  BadgeCheck04,

  // Building

  Building07,
  Building08,
  Building01,
  Building02,
  Building03,
  Building04,
  Building05,
  Building06,
  House,
  HousePlug,
  HousePlus,
  Home01,
  Home02,
  Home03,
  Home04,
  Home05,
  Home06,
  Home07,
  Home08,
  Home09,
  House01,
  House02,
  House03,
  House04,
  House05,
  HouseSolarPanel,
  Warehouse,
  LightHouse,
  GuestHouse,

  // Chats

  Comment01,
  BubbleChat,
  Message02,
  Chatting01,
  BubbleChatDone,
  WeChat,
  BubbleChatLock,
  BubbleChatSecure,
  BubbleChatUnlock,
  BubbleChatBlocked,
  BubbleChatAdd,
  BubbleChatCancel,
  BubbleChatDownload01,
  BubbleChatDownload02,
  BubbleChatIncome,
  BubbleChatNotification,
  BubbleChatOutcome,
  BubbleChatPreview,
  BubbleChatQuestion,
  BubbleChatTranslate,
  BubbleChatUpload,
  BubbleChatUser,
  BubbleChatEdit,
  MessageDone02,
  BubbleChatFavourite,
  BubbleChatSearch,
  BubbleChatDelay,
  Comment02,
  MailOpen,
  MailOpen01,
  MailOpen02,
  MessageBlocked,
  CommentRemove02,
  MailOpenLove,

  // Charts

  ChartArea,
  ChartBar,
  ChartBarBig,
  ChartBarDecreasing,
  ChartBarIncreasing,
  ChartBarStacked,
  ChartCandlestick,
  ChartColumn,
  ChartColumnBig,
  ChartColumnDecreasing,
  ChartColumnIncreasing,
  ChartColumnStacked,
  ChartLine,
  ChartNetwork,
  ChartNoAxesColumn,
  ChartNoAxesColumnDecreasing,
  ChartNoAxesColumnIncreasing,
  ChartNoAxesCombined,
  ChartNoAxesGantt,
  ChartPie,
  ChartScatter,
  ChartSpline,
  FolderKanban,
  Kanban,
  PanelsTopLeft,
  SquareChartGantt,
  SquareDashedKanban,
  SquareKanban,
  TrendingDown,
  TrendingUp,

  // Communication

  Antenna,
  AudioLine,
  AudioWaveform,
  BookHeart,
  Camera,
  CameraOff,
  CassetteTape,
  Cctv,
  ChevronsLeftRightEllipsis,
  CircleFadingPlus,
  EathernetPort,
  Lectern,
  Mic,
  MicOff,
  Newspaper,
  Nfc,
  Notebook,
  Phone,
  PhoneCall,
  PhoneMissed,
  PhoneOff,
  Presentation,
  Projector,
  Radar,
  ScreenShare,
  ScreenShareOff,
  Send,
  SendHorizontal,
  SmartphoneNfc,
  SmilePlus,
  Sticker,
  StickyNote,
  SwitchCamera,
  Tv,
  Video,
  VideoOff,
  Videotape,
  Volume,
  Volume1,
  Volume2,
  VolumeOff,
  VolumeX,
  Webcam,

  // Currency

  Banknote,
  Bitcoin,
  CircleDollarSign,
  Currency,
  DollarSign,
  Euro,
  IndianRupee,
  JapaneseYen,
  PhilippinePeso,
  PoundSterling,
  Receipt,
  ReceiptCent,
  ReceiptEuro,
  ReceiptIndianRupee,
  ReceiptJapneseYen,
  ReceiptPoundSterling,
  ReceiptRussianRuble,
  ReceiptSwissFranc,
  RussianRubie,
  SwissFranc,

  // Cursor

  CirclePlus,
  Grab,
  Loader,
  LoaderCricle,
  LoaderPinwheel,
  Pencil,
  PencilOff,
  PenTool,
  Pointer,
  PointerOff,
  Sparkles,
  Stamp,
  Text,
  TextCursor,
  TextSelect,
  Wand,
  WandSparkles,

  // Connectivity

  Airplay,
  Battery,
  BatteryCharging,
  BatteryFull,
  BatteryLow,
  BatteryMedium,
  BattreyWarning,
  Bluetooth,
  BluetoothConnected,
  BluetoothOff,
  BluetoothSearching,
  Cable,
  Cast,
  CirclePower,
  ColudOff,
  Headphones,
  Headset,
  Monitor,
  MonitorCheck,
  MonitorCog,
  MonitorDot,
  MonitorDown,
  MonitorOff,
  MonitorPause,
  MonitorPlay,
  MonitorSmartphone,
  MonitorSpeaker,
  MonitorStop,
  MonitorUp,
  MonitorX,
  NootbookTabs,
  Power,
  PowerOff,
  Router,
  Satellite,
  SatelliteDish,
  Signal,
  SignalHigh,
  SignalLow,
  SignalMedium,
  SignalZero,
  Smartphone,
  SmartphoneCharging,
  SquarePower,
  Voicemail,
  Wifi,
  WifiHigh,
  WifiLow,
  WifiOff,
  WifiZero,
  Zap,
  ZapOff,

  // Design

  AArrowDown,
  AArrowUp,
  ALargeSmall,
  AppWindow,
  AppWindowMac,
  Axis3d,
  BetweenVerticalEnd,
  BetweenVerticalStart,
  Blend,
  BookType,
  BoxSelect,
  BringToFront,
  Brush,
  Columns2,
  Columns3,
  Columns4,
  Component,
  Crop,
  Cylinder,
  Diameter,
  Dock,
  DraftingCompass,
  FileAxis3d,
  FlipHorizontal,
  FlipHorizontal2,
  FlipVertical,
  FlipVertical2,
  Frame,
  Fullscreen,
  GalleryHorizontal,
  GalleryHorizontalEnd,
  GalleryThumbnails,
  GalleryVertical,
  GalleryVerticalEnd,
  Grid2X2,
  Grid2X2Check,
  Grid2X2X,
  Grid3X3,
  Highlighter,
  IterationCc,
  LandPlot,
  Lasso,
  Layers,
  Layers2,
  Layers3,
  LayoutDashboard,
  LayoutGrid,
  LayoutPanelLeft,
  Magnet,
  Maximize,
  Minimize,
  Move3D,
  Nootbook,
  PaintRoller,
  Palette,
  PanelTop,
  Paperclip,
  Pen,
  PencilLine,
  Pipette,
  Proportions,
  Radius,
  Ratio,
  RectangleHorizontal,
  RectangleVertical,
  Rotate3D,
  Rows2,
  Rows3,
  Rows4,
  Ruler,
  Scale3D,
  Scaling,
  ScissorsLineDashed,
  SendToBack,
  Slice,
  Spline,
  SprayCan,
  SquareBottomDashedScissors,
  SquareScissors,
  SwatchBook,
  TableSmartphone,
  Torus,
  View,

  // Codeing

  Ampersand,
  Ampersands,
  Asterisk,
  Binary,
  Binoculars,
  Blocks,
  Book,
  BookCheck,
  BookCopy,
  BookDashed,
  BookDown,
  BookKey,
  BookLock,
  BookMarked,
  BookMinus,
  BookOpen,
  BookOpenCheck,
  BookOpenText,
  BookPlus,
  BookText,
  BookUp,
  BookUp2,
  BookX,
  Bot,
  BotMessageSquare,
  BotOff,
  Box,
  Boxes,
  Braces,
  Brackets,
  BrainCircuit,
  BrainCog,
  CircleDashed,
  CircleDot,
  CircleDotDashed,
  CircleEllipsis,
  CircleSlash2,
  CircleX,
  CircuitBoard,
  CloudCog,
  CodePen,
  Code,
  CodeXml,
  Combine,
  Command,
  Computer,
  Construction,
  CopySlash,
  DataBase,
  DataBaseBackup,
  DatabaseZap,
  Diff,
  Divide,
  EarthLock,
  Equal,
  EqualNot,
  FileCode,
  FileDiff,
  FileDigit,
  FileJson,
  FileJosn2,
  FileSliders,
  FileStack,
  FileTerminal,
  FlagTriangleLeft,
  FlagTriangleRight,
  FolderCode,
  FolderDot,
  FolderOpneDot,
  FolderRoot,
  Gem,
  GitCommitHorizontal,
  GitBranch,
  GitBranchPlus,
  GitCommitVertical,
  GitGraph,
  GitLab,
  GitMerge,
  GlobeLock,
  HardDrive,
  Heading,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Heading5,
  Heading6,
  Hexagon,
  IndentDecrease,
  IndentIncrease,
  Keyboard,
  KeyboardOff,
  Library,
  LibraryBig,
  MemoryStick,
  Minus,
  Network,
  Omega,
  Option,
  Package,
  Package2,
  PackageMinus,
  PackageOpen,
  PackageSearch,
  PackageX,
  Parentheses,
  Percent,
  Pi,
  Plug,
  Plug2,
  Pocket,
  Puzzle,
  QrCode,
  Radical,
  RectangleElliopsis,
  Regex,
  Rocket,
  Rss,
  Scroll,
  ScrollText,
  Server,
  ServerCog,
  ServerCrash,
  ServerOff,
  Slash,
  SpellCheck,
  SpellCheck2,
  SquareDashedBottom,
  SquareDashedBottomCode,
  SquareDot,
  SquareFunction,
  SquareLibrary,
  SquareMinus,
  SquarePi,
  SquarePlus,
  SquareRadical,
  SquareSlash,
  SquareStack,
  SquareTerminal,
  TablePropertise,
  Telescope,
  Terminal,
  Trello,
  TriangleAlert,
  Unplug,
  Variable,
  WorkFlow,

  // Devices

  AlarmClock,
  AlarmClockCheck,
  AlarmClockOff,
  AlarmClockPlus,
  AlarmSmoke,
  BellElectric,
  Calculator,
  Cpu,
  DaimondMinus,
  DaimondPlus,
  Disc,
  Disc2,
  Disc3,
  DiscAlbum,
  Drill,
  Drum,
  Flashlight,
  FlashlightOff,
  Gamepad,
  Gamepad2,
  HdmiPort,
  Joystick,
  KeyboardMusic,
  Laptop,
  LaptopMinimal,
  Microchip,
  MicVocal,
  Mouse,
  MouseOff,
  PcCase,
  Piano,
  PlugZap,
  RadioReceiver,
  RadioTower,
  Scan,
  ScanLine,
  ScanText,
  Speaker,
  Tablet,
  TabletSmartphone,
  TvMinimal,
  TvMinimalPlay,
  Usb,
  VoiceMail,

  // Emoji

  Angry,
  Annoyed,
  BicepsFlexed,
  HandHelping,
  HandMetal,
  HeartCrack,
  HeartHandShake,
  Laugh,
  LeafyGreen,
  Meh,
  PartyPopper,
  Ribbon,
  Salad,

  // File

  Archive,
  ArchiveRestore,
  ArchiveX,
  BookImage,
  CalenderFold,
  FileArchive,
  FileAudio,
  FileAudio2,
  FileAxis3D,
  FileBadge,
  FileBox,
  FileChartColumn,
  FileChartColumnIncreasing,
  FileChartLine,
  FileChartPie,
  FileCheck,
  FileCheck2,
  FileClock,
  FileCog,
  FileHeart,
  FileImage,
  FileJson2,
  FileKey,
  FileKey2,
  FileLock,
  FileLock2,
  FileMinus,
  FIleMinus2,
  FileMusic,
  FilePen,
  FilePenLine,
  FilePlus,
  FilePlus2,
  Files,
  FileScan,
  FileSearch,
  FileSearch2,
  FileSlider,
  FileSpreadsheet,
  FileText,
  FileType,
  FileType2,
  FileVideo,
  FileVideo2,
  FileVolume,
  FileVolume2,
  FileX,
  FileX2,
  Folder,
  FolderArchive,
  FolderCheck,
  FolderClock,
  FolderClosed,
  FolderCog,
  FolderGit,
  FolderGit2,
  FolderHeart,
  FolderKey,
  FolderLock,
  FolderMinus,
  FolderOpen,
  FolderOpenDot,
  FolderPen,
  FolderPlus,
  Folders,
  FolderSearch,
  FolderSearch2,
  FileSymilink,
  FolderTree,
  FolderX,
  Group,
  Image,
  Images,
  ImageDown,
  ImageMinus,
  ImageOff,
  ImagePlay,
  ImagePlus,
  ListTree,
  Music,
  Music2,
  Music3,
  Music4,
  PaperClip,
  Save,
  SaveAll,
  SaveOff,
  Sheet,
  TableCellsSplit,
  TableColumnsSplit,
  TableProperties,
  TableRowsSplit,
  Trash,
  Trash2,
  Ungroup,

  // Food

  Amphora,
  Apple1,
  Banana,
  Bean,
  BeanOff,
  Beer,
  BeerOff,
  CakeSlice,
  Candy,
  CandyCane,
  CandyOff,
  Carrot,
  Cherry,
  Citrus,
  Coffee,
  CokingPot,
  Croissant,
  CupSoda,
  Dessert,
  DnaOff,
  Donut,
  DrumStick,
  EggOff,
  EggFried,
  GlassWater,
  Grape,
  Ham,
  HandPlater,
  Hop,
  HopOff,
  IceCreamBowl,
  IceCreamCone,
  Lollipop,
  Martini,
  Microwave,
  Milk,
  Nut,
  NutOff,
  Pizza,
  Popcorn,
  Popsicle,
  Refrigerator,
  SandWich,
  ShefHat,
  Soup,
  Tractor,
  Utensils,
  UtlensilsCrossed,
  Vegan,
  Wheat,
  Wheatoff,
  Wine,
  WineOff,

  // Furniture

  Armchair,
  Bed,
  BedDouble,
  BedSingle,
  DoorClosed,
  DoorOpen,
  Lamp,
  LampCeiling,
  LampDesk,
  LampFloor,
  LampWallDown,
  LampWallUp,
  RockingChair,

  // gaming

  Axe,
  Backpake,
  Beaker,
  Clover,
  Club,
  Coins,
  Dice1,
  Dice2,
  Dice3,
  Dice4,
  Dice5,
  Dice6,
  Dices,
  Droplet,
  Feather,
  Flame,
  FlameKinding,
  FlaskConical,
  FlaskConicalOff,
  FlaskRound,
  Flower,
  Ghost,
  Goal,
  HourGlass,
  Medal,
  Memorystick,
  MileSton,
  Mountain,
  Pickaxe,
  Scane,
  Scrolltext,
  Shapes,
  Shovel,
  SingPost,
  SingPostBig,
  Skull,
  Spade,
  Sprout,
  Sword,
  Tally1,
  Tally2,
  Tally3,
  Tally4,
  Tally5,
  Target,
  Trophy,
  VenetianMask,

  // Home

  AirVent,
  Blinds,
  CookingPot,
  Fan,
  FireExtinguisher,
  Hammer,
  Refrigeator,
  ShowerHead,
  UnityPool,
  Vault,

  // Layout

  AlignCenterHorizontal,
  AlignCenterVertical,
  AlignEndHorizontal,
  AlignEndVertical,
  AlignHorizontalDistributeCenter,
  AlignHorizontalDistributeEnd,
  AlignHorizontalDistributeStart,
  AlignHorizontalJustifyCenter,
  AlignHorizontalJustifyEnd,
  AlignHorizontalJustifyStart,
  AlignHorizontalSpaceAround,
  AlignHorizontalSpaceBetween,
  AlignStartHorizontal,
  AlignStartVertical,
  AlignVerticalDistributeCenter,
  AlignVerticalDistributeEnd,
  AlignVerticalDistributeStart,
  AlignVerticalJustifyCenter,
  AlignVerticalJustifyEnd,
  AlignVerticalJustifyStart,
  AlignVerticalSpaceAround,
  AlignVerticalSpaceBetween,
  EllipsisVertical,
  Filter,
  FilterX,
  Grid2x2,
  Grid2x2Check,
  Grid2x2X,
  Grid3x3,
  Grip,
  GripHorizontal,
  GripVertical,
  LayoutTemplate,
  LoaderCircle,
  PanelBottom,
  PanelBottomDashed,
  PanelLeft,
  PanelLeftDashed,
  PanelRight,
  PanelRightDashed,
  PanelsLeftBottom,
  PanelsRightBottom,
  PanelTopDashed,
  PencilRuler,
  Signature,
  SquareSplitHorizontal,
  SquareSplitVertical,
  SquareSquare,
  StretchHorizontal,
  StretchVertical,
  TextCursorInput,

  // Mail

  Container,
  Forward,
  Mailbox,
  MailCheck,
  MailMinus,
  MailPlus,
  MailQuestion,
  Mails,
  MailSearch,
  MailWarning,
  MailX,
  Reply,
  ReplyAll,

  // Medical

  Ambulance,
  Bandage,
  Brain,
  BriefcaseMedical,
  Cigarette,
  CigaretteOff,
  ClipboardMinus,
  ClipboardPlus,
  Dna,
  HeartPulse,
  Microscope,
  Pill,
  PillBottle,
  Siren,
  Stethoscope,
  Syringe,
  Tablets,

  // Maps

  Anchor,
  BookA,
  CircleParking,
  CircleParkingOff,
  Compass,
  Dumbbell,
  Earth,
  FerrisWheel,
  Footprints,
  Fuel,
  Gavel,
  Globe,
  Locate,
  LocateFixed,
  LocateOff,
  Map,
  Navigation,
  Navigation2,
  Navigation2Off,
  NavigationOff,
  ParkingMeter,
  PinOff,
  RailSymbol,
  RollerCoaster,
  Route,
  RouteOff,
  Scale,
  Ship,
  ShipWheel,
  SquareM,
  SquareParking,
  SquareParkingOff,
  TrainFrontTunnel,
  TrainTrack,
  UtensilsCrossed,
  Waves,

  // Maths

  CircleDivide,
  CircleEqual,
  CircleMinus,
  CircleSlash,
  Cone,
  CopyMinus,
  CopyPlus,
  OctagonX,
  Pyramid,
  Sigma,
  SquareDivide,
  SquareEqual,
  SquareSigma,
  SquareX,
  Tangent,
  Tangent2,
  Weight,
  XNum,

  // Multimedia

  AudioLines,
  BookAudio,
  BookHeadphones,
  BoomBox,
  Captions,
  CaptionsOff,
  CirclePause,
  CirclePlay,
  CircleStop,
  Clapperboard,
  DiamondMinus,
  DiamondPlus,
  Drama,
  Film,
  Guitar,
  Heart1,
  HeartOff,
  Infinit,
  ListEnd,
  ListMinus,
  ListMusic,
  ListPlus,
  ListRestart,
  ListStart,
  ListVideo,
  ListX,
  Megaphone,
  MegaphoneOff,
  OctagonPause,
  Pause,
  PictureInPicture,
  PictureInPicture2,
  Podcast,
  Repeat1,
  StarHalf,
  StarOff,

  // Nature

  Cannabis,
  Caravan,
  FlameKindling,
  Flower2,
  Leaf,
  MountainSnow,
  Tent,
  TentTree,
  TreeDecidous,
  TreePalm,
  TreePine,
  Trees,

  //  Text

  AlignCenter,
  AlignJustify,
  AlignLeft,
  AlignRight,
  Baseline,
  Bold,
  CaseLower,
  CaseSensitive,
  CaseUpper,
  ClipboardCheck,
  ClipboardList,
  ClipboardPen,
  ClipboardType,
  ClipboardX,
  CopyCheck,
  Eraser,
  Expand,
  Hash,
  Italic,
  Languages,
  LayoutList,
  LetterText,
  Ligature,
  List,
  ListCheck,
  ListChecks,
  ListCollapse,
  ListFilter,
  ListTodo,
  Logs,
  NotebookPen,
  NotebookText,
  NotepadText,
  NotepadTextDashed,
  PaintbrushVertical,
  PenOff,
  Pilcrow,
  PilcrowLeft,
  PilcrowRight,
  Quote,
  RectangleEllipsis,
  RemoveFormatting,
  Replace,
  ReplaceAll,
  Section,
  Space,
  SquareCode,
  SquarePen,
  SquarePilcrow,
  Strikethrough,
  Subscript,
  Superscript,
  TextQuote,
  TextSearch,
  Type,
  TypeOutline,
  Underline,
  Unlink,
  Unlink2,
  WholeWord,

  Plus,
  Scissors,
  Check,
  Copy,
  Close,

  // Users

  User,
  UserAccount,
  UserAdd01,
  UserAdd02,
  UserArrowLeftRight,
  UserBlock01,
  UserBlock02,
  UserCheck01,
  UserCheck02,
  UserCircle,
  UserEdit01,
  UserFullView,
  UserGroup02,
  UserGroup01,
  UserList,
  UserLock01,
  UserLock02,
  UserLove01,
  UserLove02,
  UserMinus01,
  UserMinus02,
  UserQuestion01,
  UserQuestion02,
  UserRemove01,
  UserRemove02,
  UserSearch01,
  UserSearch02,
  UserSettings01,
  UserSettings02,
  UserSharing,
  UserShield01,
  UserShield02,
  UserSquare,
  UserStar01,
  UserStar02,
  UserStatus,
  UserStory,
  UserSwitch,
  UserUnlock01,
  UserUnlock02,
  UserPlus,
  UserRound,
  UserRoundCheck,
  UserRoundCog,
  UserRoundMinus,
  UserRoundPen,

  // Brands
  X,
  Apple,
  Behance,
  BehanceFull,
  Figma,
  LinkedIn,
  NPM,
  Nextjs,
  YouTube,
  Facebook,
  Instagram,
  Threads,
  ThreadsFill,
  Nike,
  Vercel,
  VercelFull,
  Wordpress,
  WhatsApp,
  Typescript,

  Heart: ({ ...props }: DesignaliProps) => (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="heart"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 205.18 156.34"
      {...props}
    >
      <path
        fill="currentColor"
        d="M102.38,33.66c3.14-4.85,5.82-9.75,9.22-14.1,7.83-10.01,18.16-16.19,30.73-18.32,12.49-2.12,24.76-1.29,36.21,4.51,13.93,7.06,22.26,18.56,25.34,33.85,1.9,9.41,1.69,18.82-.42,28.18-2.51,11.12-8.64,19.81-17.73,26.55-8.89,6.59-18.89,11.1-28.91,15.58-10.02,4.47-19.96,9.09-29.11,15.24-11.03,7.42-19.98,16.48-24.22,29.46-.15,.47-.39,.91-.75,1.74-.56-1.16-1.09-2.03-1.41-2.97-4.17-12.37-12.98-20.86-23.41-27.98-10.7-7.31-22.46-12.53-34.3-17.65-9.47-4.09-18.57-8.88-26.76-15.31C7.56,85.11,2.78,75.33,.98,63.98c-1.6-10.1-1.38-20.19,1.8-30.06C7.47,19.38,16.95,9.11,31.15,3.8c13.86-5.18,28.06-5.05,41.92,.32,12.14,4.7,20.75,13.52,26.93,24.82,.87,1.59,1.64,3.23,2.39,4.72Z"
      ></path>
    </svg>
  ),
};
